import React, {
  ComponentProps,
  ComponentType,
  ReactNode,
  useState,
} from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Box, Flex, Icon, NakedButton } from '@qga/roo-ui/components';

import useSize from '../../hooks/useSize';

const Truncate = styled(Box)`
  overflow: hidden;

  ${(props: { truncated?: boolean; lines?: number }) =>
    props.truncated &&
    props.lines &&
    css`
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${props?.lines < 1 ? 'unset' : props.lines};
    `}
`;

const DefaultButton = (props: ComponentProps<typeof NakedButton>) => (
  <NakedButton color="ui.link" hoverColor="ui.linkHover" {...props} />
);

export type ReadMoreTextProps = {
  maxLines: number;
  children: ReactNode;
  ButtonComponent?: ComponentType<{
    children?: ReactNode;
    onClick?: () => any;
    isExpanded?: boolean;
  }>;
};

const ReadMoreText = ({
  maxLines = 1,
  children,
  ButtonComponent = DefaultButton,
}: ReadMoreTextProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { height: containerHeight, ref: containerRef } = useSize();
  const { scrollHeight: contentScrollHeight, ref: contentRef } = useSize();

  const showExpandButton = isExpanded || contentScrollHeight > containerHeight;
  const onClick = () => {
    setIsExpanded((isExpanded) => !isExpanded);
  };

  return (
    <Box>
      <Truncate
        data-testid="LINE_CLAMP"
        id="read_more"
        truncated={!isExpanded}
        lines={maxLines}
        ref={containerRef}
        mb={showExpandButton ? 4 : 0}
      >
        {/* @ts-ignore */}
        <div ref={contentRef}>{children}</div>
      </Truncate>
      {showExpandButton && (
        <ButtonComponent isExpanded={isExpanded} onClick={onClick}>
          <Flex fontWeight="bold" alignItems="center">
            {isExpanded ? 'Show less' : 'Show more'}
            <Icon name={isExpanded ? 'expandLess' : 'expandMore'} />
          </Flex>
        </ButtonComponent>
      )}
    </Box>
  );
};

export default ReadMoreText;
